@if (subNav) {
  <div class="sub-nav">
    <ul class="nav nav-tabs">
      @for (nav of subNav; track nav) {
        <li class="nav-item">
          <a
            class="nav-link"
            [routerLink]="nav.route"
            [class.active]="nav.id === currentNav?.id"
            >{{ nav.name }}</a
          >
        </li>
      }
    </ul>
  </div>
}
